import { supabase } from '../../lib/supabase';

const LOGO_BUCKET = 'institute-branding';

/**
 * The institute-branding bucket is public (see the migration comment on
 * `institutes.logo_path`), so the URL builds synchronously — no signed-URL
 * round trip that could still be in flight when `window.print()` fires.
 */
export function institutionLogoUrl(logoPath: string | null): string | null {
  if (logoPath === null || logoPath === '') return null;
  return supabase.storage.from(LOGO_BUCKET).getPublicUrl(logoPath).data.publicUrl;
}

const LOGO_MIME_EXT: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
};

/**
 * One logo per institute at a fixed path, upserted on re-upload — unlike
 * finance-receipts' timestamped-unique-file pattern, there is nothing to keep
 * a history of here, and a fixed path means `institutes.logo_path` never has
 * to change once set.
 */
export async function uploadInstituteLogo(instituteId: string, file: File): Promise<string> {
  const ext = LOGO_MIME_EXT[file.type];
  if (ext === undefined) {
    throw new Error('Logo must be a PNG, JPEG or WebP image.');
  }
  const path = `${instituteId}/logo.${ext}`;
  const { error } = await supabase.storage
    .from(LOGO_BUCKET)
    .upload(path, file, { upsert: true, contentType: file.type });
  if (error !== null) throw new Error(error.message);
  return path;
}
